import { PDFCatalogue } from '@/components/PDFCatalogue';
import './index.css';

export function App() {
  return <PDFCatalogue />;
}

export default App;
